module.exports = __webpack_public_path__ + "img/straight-rail-horizontal-stone-path.23f15093.png";